import EditSelectEditor from './SelectFieldEditor';

const FieldEditors: Record<string, React.FC<FieldEditorProps>> = {
  SelectField: EditSelectEditor,
};

export default FieldEditors;
